module.exports = __webpack_public_path__ + "static/media/16UNODC40.687775b8.jpg";